import React from "react";
import { Flex as AFlex } from "antd"; // Import Ant Design Flex component
import { useBreakpoint } from "../../hooks";
/**
 * Flex Component
 *
 * A wrapper around the Ant Design `Flex` component for easy reuse and customization.
 *
 * Props:
 * @param {Object} props - Props passed directly to the Ant Design Flex component.
 *
 * Features:
 * - Simple wrapper that allows passing any valid props to Ant Design's Flex component.
 * - Provides a consistent interface for layout adjustments across the application.
 */

function Flex(props) {
  const { gap } = props;
  const { isMedium } = useBreakpoint();
  // Render the Ant Design Flex component with the provided props
  return <AFlex {...props} gap={isMedium ? gap : 10} />;
}

export default Flex;
